import type { Guid } from '~/types/util'
import { ProfileStore } from '~/stores/profile'
import { SessionStore } from '~/stores/session'

export class Integrations {
  static setIdentity(profileId: Guid) {
    if (process.client) {
      const { identify: analyticsIdentify } = Analytics.use()
      const { identify: flagsIdentify } = FeatureFlags.use()
      // const { identify: sentryIdentify } = Sentry.use()
      const { identify: replayIdentify } = SessionReplay.use()

      const profile = ProfileStore.use()
      const { sessionId } = CookieJar.use()

      const traits = {
        email: profile.emailAddress?.address,
        mobilePhone: profile.primaryContactPhone?.number,
        sessionId: sessionId.value
      }

      //amazon_connect('contactAttributes', { profile_id: 'changed id' })

      //console.log('AMAZON attributes set', amazon_connect)

      analyticsIdentify(profileId, traits)
      flagsIdentify(profileId)
      // sentryIdentify(profileId)
      replayIdentify(profileId)
    }
  }
}
